import {Component, EventEmitter, Input, Output} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Component({
    selector: 'app-file-upload-dnd-area',
    templateUrl: './file-upload-dnd-area.component.html',
    styleUrls: ['./file-upload-dnd-area.component.scss'],
    standalone: false
})
export class FileUploadDndAreaComponent {
    @Input() disabled: boolean | null = false;

    @Output() fileSelect = new EventEmitter<File[]>();

    dndMessageVisible$ = new BehaviorSubject(false);

    onDrop(event: any): void {
        event.preventDefault();
        event.stopPropagation();

        if (this.disabled) {
            return;
        }

        this.dndMessageVisible$.next(false);

        const fileList: File[] = Array.from(event.dataTransfer.files);

        this.fileSelect.emit(fileList);
    }

    onDragOver(event: any): void {
        event.preventDefault();
        event.stopPropagation();

        if (this.disabled) {
            return;
        }

        this.dndMessageVisible$.next(true);
    }

    onDragLeave(event: any): void {
        event.preventDefault();
        event.stopPropagation();

        if (this.disabled) {
            return;
        }

        this.dndMessageVisible$.next(false);
    }
}
